export default "<div [class]=\"class\">\r\n    <mat-spinner [diameter]=\"diameter\"></mat-spinner>\r\n</div>\r\n"